export default __webpack_public_path__ + "static/invimatic-social-icon-c064c3337b18ec4fef1f9f0b44530db3.png";